import React, { useState, forwardRef, useImperativeHandle } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import CloseIcon from "@mui/icons-material/Close";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import { Global } from "@emotion/react";
import ScopedCssBaseline from "@mui/material/ScopedCssBaseline";
import "react-loading-skeleton/dist/skeleton.css";
import { hideIntercom, showIntercom } from "../utils/Utils.js";
import SubmitBtn from "./submitButton.jsx";

const PleaseLoginPrompt = forwardRef(({ prompt, desc, icon }, ref) => {
  useImperativeHandle(ref, () => ({
    handleOpen,
  }));

  const [openModal, setOpenModal] = useState(false);
  const [openDrawer, setOpenDrawer] = useState(false);

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const navTabs = document.querySelector(".tabsContainer");

  if (openModal || openDrawer) {
    hideIntercom();
    if (navTabs) {
      navTabs.style.marginRight = "10px";
    }
    if (!document.getElementById("homepage"))
      document.documentElement.style.overflow = "hidden";
    document.querySelector("body").style.marginRight = `10px`;
  } else {
    showIntercom();
    if (!document.getElementById("homepage"))
      document.documentElement.style.overflow = "unset";
    document.querySelector("body").style.marginRight = `0px`;
    if (navTabs) {
      navTabs.style.marginRight = "0";
    }
  }

  const drawerBleeding = 88;

  const StyledBox = styled(Box)(({ theme }) => ({
    backgroundColor: "#fff",
  }));

  const Puller = styled(Box)(({ theme }) => ({
    width: 48,
    height: 4,
    backgroundColor: "#701bff",
    borderRadius: 3,
    position: "absolute",
    top: 16,
    left: "calc(50% - 24px)",
  }));

  const StyledDialogContent = styled(DialogContent)(({ theme }) => ({
    padding: "24px !important",
  }));

  const destroyModal = () => {
    $("#modal").remove();
  };

  const handleOpen = () => {
    if (navTabs) {
      navTabs.style.marginRight = "10px";
    }
    if (fullScreen) {
      setOpenDrawer(true);
      setOpenModal(false);
    }
    if (!fullScreen) {
      setOpenModal(true);
      setOpenDrawer(false);
    }
    hideIntercom();
    if (!document.getElementById("homepage"))
      document.documentElement.style.overflow = "hidden";
    document.querySelector("body").style.marginRight = `10px`;
  };

  const handleClose = () => {
    if (navTabs) {
      navTabs.style.marginRight = "0";
    }
    showIntercom();
    if (!document.getElementById("homepage"))
      document.documentElement.style.overflow = "unset";
    document.querySelector("body").style.marginRight = `0px`;
    destroyModal();
    setOpenModal(false);
    setOpenDrawer(false);
  };

  return (
    <ScopedCssBaseline sx={{ display: "contents" }}>
      <Global
        styles={{
          ".MuiDrawer-root > .MuiPaper-root": {
            maxHeight: `calc(100% - ${drawerBleeding}px)`,
            borderTopLeftRadius: 16,
            borderTopRightRadius: 16,
            "*::-webkit-scrollbar": {
              width: "7px",
            },
            "*::-webkit-scrollbar-track": {},
            "*::-webkit-scrollbar-thumb": {
              backgroundColor: "#CFD1D1",
              borderRadius: "5px ",
            },
            "*::-webkit-scrollbar-thumb:hover": {
              backgroundColor: "#703EFF",
            },
          },
          ".MuiDialog-paper": {
            "*::-webkit-scrollbar": {
              width: "7px",
            },
            "*::-webkit-scrollbar-track": {},
            "*::-webkit-scrollbar-thumb": {
              backgroundColor: "#CFD1D1",
              borderRadius: "5px ",
            },
            "*::-webkit-scrollbar-thumb:hover": {
              backgroundColor: "#703EFF",
            },
          },
          ".MuiDialogTitle-root": {
            padding: "24px !important",
          },
        }}
      />
      {fullScreen ? (
        <SwipeableDrawer
          anchor="bottom"
          open={openDrawer}
          onOpen={handleOpen}
          onClose={() => handleClose()}
          disableSwipeToOpen={false}
          disableScrollLock={false}
        >
          <StyledBox
            sx={{
              top: -drawerBleeding,
              borderTopLeftRadius: 16,
              borderTopRightRadius: 16,
              visibility: "visible",
              right: 0,
              left: 0,
            }}
          >
            <Puller />
          </StyledBox>
          <StyledBox
            sx={{
              px: 2,
              pb: 2,
              overflow: "auto",
              marginTop: "48px",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 24,
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: 8,
                }}
              >
                <img src={icon} style={{ width: 124, height: 124 }} />
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 4,
                  }}
                >
                  <span
                    style={{
                      fontSize: 20,
                      fontFamily: "pf_highway_sans_pro_mediumRg",
                      textAlign: "center",
                    }}
                  >
                    {prompt}
                  </span>
                  {desc && (
                    <span style={{ fontSize: 16, textAlign: "center" }}>
                      {desc}
                    </span>
                  )}
                </div>
              </div>
              <div style={{ display: "flex", width: "60%" }}>
                <SubmitBtn
                  toDoOnClick={LoginClick}
                  buttonText={tickets_resources.SignIn}
                  isBottom
                />
              </div>
            </div>
          </StyledBox>
        </SwipeableDrawer>
      ) : (
        <Dialog
          open={openModal}
          onClose={() => handleClose()}
          aria-labelledby="responsive-dialog-title"
          PaperProps={{
            sx: {
              bgcolor: "white",
              maxWidth: "revert",
              borderRadius: "8px",
              width: 560,
            },
          }}
        >
          <DialogTitle
            className="r_dialogTitle"
            style={{
              position: "absolute",
              justifyContent: "flex-end",
            }}
          >
            <CloseIcon onClick={handleClose} className="r_dialogTitleIcon" />
          </DialogTitle>
          <StyledDialogContent>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 24,
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: 8,
                }}
              >
                <img src={icon} style={{ width: 124, height: 124 }} />
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 4,
                  }}
                >
                  <span
                    style={{
                      fontSize: 20,
                      fontFamily: "pf_highway_sans_pro_mediumRg",
                      textAlign: "center",
                    }}
                  >
                    {prompt}
                  </span>
                  {desc && (
                    <span style={{ fontSize: 16, textAlign: "center" }}>
                      {desc}
                    </span>
                  )}
                </div>
              </div>
              <div style={{ display: "flex", width: "60%" }}>
                <SubmitBtn
                  toDoOnClick={LoginClick}
                  buttonText={tickets_resources.SignIn}
                  isBottom
                />
              </div>
            </div>
          </StyledDialogContent>
        </Dialog>
      )}
    </ScopedCssBaseline>
  );
});

export default PleaseLoginPrompt;
